import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IContactsTierSelectSlice {
  contactsTier: string;
  contactsTierSelectDisabled: boolean;
}

export const createContactsTierSelectSliceDefaultValues = (): IContactsTierSelectSlice => ({
  contactsTier: '0',
  contactsTierSelectDisabled: false,
});

export const createContactsTierSelectSlice: StateCreator<IContactsTierSelectSlice> = () =>
  createContactsTierSelectSliceDefaultValues();

export type ContactsTierSelectPageStore = UseBoundStore<StoreApi<IContactsTierSelectSlice>>;

export const createContactsTierSelectHooks = (pageStore: ContactsTierSelectPageStore) => {
  return {
    useContactsTier: () => pageStore((state) => state.contactsTier),
    useDisabled: () => pageStore((state) => state.contactsTierSelectDisabled),
  };
};

export type ContactsTierSelectHooks = ReturnType<typeof createContactsTierSelectHooks>;
